import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { MoverEntity } from './mover.entity';

@Entity('_mover_workd_component')
export class MoverWorkdComponentEntity extends BaseEntity {
	@Column('varchar', { name: '_alias', length: 255 })
	public alias!: string;

	@Column('varchar', {
		name: '_module',
		length: 64,
		default: () => "'instance'",
	})
	public module!: string;

	@Column('varchar', { name: '_url', nullable: true, length: 255 })
	public url!: string | null;

	@OneToMany(() => MoverEntity, (mover) => mover.fkMoverWorkdComponent, {})
	public movers!: Array<MoverEntity>;
}
